import Experience from '../Experience.js'
import Environment from './Environment.js'
import Page from './Page.js'

export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.camera = this.experience.camera;
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.html = this.experience.html
        this.sound = this.experience.sound
        this.debug = this.experience.debug.panel

        const percentEl = document.getElementById("preloader-percent");
        const barEl = document.getElementById("preloader-bar");
        const textEl = document.getElementById("preloader-text");

        this.resources.on('progress', (progress, name) => {
            const pct = Math.round(progress * 100);
            if (percentEl) percentEl.innerText = `${pct}%`;
            if (barEl) barEl.style.width = `${pct}%`;
            if (textEl && name) {
                textEl.innerText = name === 'COMPLETE' 
                    ? 'COMPILING FBO GPU PARTICLES...' 
                    : `LOADING MESH: ${name.toUpperCase()}... [${pct}%]`;
            }
        });

        this.resources.on('ready', () =>
        {
            if (percentEl) percentEl.innerText = "100%";
            if (barEl) barEl.style.width = "100%";
            if (textEl) textEl.innerText = "READY";

            this.experience.time.start = Date.now()
            this.experience.time.elapsed = 0

            this.page = new Page()
            this.environment = new Environment()

            setTimeout(() => {
                if (this.html.preloader) {
                    this.html.preloader.classList.add("preloaded");
                    setTimeout(() => {
                        this.html.preloader.style.display = "none";
                    }, 800);
                }
                if (this.html.playButton) {
                    this.html.playButton.remove();
                }
            }, 300);

            this.animationPipeline();
        })
    }

    animationPipeline() {
        if ( this.camera )
            this.camera.animateCameraPosition()
    }

    resize() {
        if ( this.page )
            this.page.resize()
    }

    scroll()
    {
        if ( this.page )
            this.page.scroll()
    }

    update()
    {
        if(this.page)
            this.page.update()
    }
}
